import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Paper,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useContext, useEffect, useRef, useState } from "react";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import AppDataContext from "../../../common/appContext";
import {
  getDropDown,
  getInputBox,
} from "../../../sharedComponents/formFields/LabelInFormFields";
import Loader from "../../../sharedComponents/loader/loader";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import AppConstatnts from "../../../common/AppConstants";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";

const HighSchoolDetailsViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  viewProfile,
  setAlert,
  setAlertType,
  setAlertMessage,
  //   user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    eventId: eventId,
    contact: "",
    email: "",
    id: 0,
    mode: null,
    phone: "",
    playerID: playerID,
    schoolName: "",
    state: "",
    townOrCity: "",
    userBy: user?.loginID,
    years: "",
  };
  const defaultErrors = {
    email: false,
    years: false,
  };
  const defaultErrorMsg = {
    email: "",
    years: "",
  };
  const [highSchoolGridData, setHighSchoolGridData] = useState([]);
  const [highSchoolFormData, setHighSchoolFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );

  const columns = [
    { field: "id", hide: true, flex: 1 },
    {
      field: "years",
      headerName: "High School Year",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "schoolName",
      headerName: "High School",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "townOrCity",
      headerName: "High School Town/City",
      width: 190,
      flex: columnFlex,
    },
    {
      field: "state",
      headerName: "High School State",
      width: 180,
      flex: columnFlex,
    },
    {
      field: "contact",
      headerName: "High School Contact",
      width: 190,
      flex: columnFlex,
    },
    {
      field: "phone",
      headerName: "High School Contact Phone",
      width: 220,
      flex: columnFlex,
    },
    {
      field: "email",
      headerName: "High School Contact Email",
      width: 200,
      flex: columnFlex,
    },
  ];

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  useEffect(() => {
    setHighSchoolFormData(formData);
    setHighSchoolGridData(gridPropsData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };

  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return highSchoolFormData.years ||
      highSchoolFormData.schoolName ||
      highSchoolFormData.townOrCity ||
      highSchoolFormData.state ||
      highSchoolFormData.contact ||
      highSchoolFormData.email ||
      highSchoolFormData.phone
      ? false
      : true;
  };

  //---HANDLERS---

  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the high school details to edit from grid data
  //2. set the input boxes with high school details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = highSchoolGridData.find((hs, i) => {
      return hs.id === id;
    });
    setHighSchoolFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setHighSchoolFormData(formData);
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveCLick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(highSchoolFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = highSchoolGridData.find((hs, i) => {
      return hs.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(
          true,
          "success",
          "High school record deleted Successfully."
        );
      }
    }
  };

  const handleInputChange = (e, key) => {
    let value = e.target.value;
    let defaultVal = "";
    switch (key) {
      case "years":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.YEAR_REGEX)
        )
          toggleError(key, true, "Invalid Year");
        else toggleError(key, false, "");
        break;
      case "email":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.EMAIL_REGEX)
        )
          toggleError(key, true, "Invalid Email");
        else toggleError(key, false, "");
        break;
    }
    setHighSchoolFormData({
      ...highSchoolFormData,
      [key]: value || defaultVal,
    });
  };

  //---APIs---

  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    setIsLoading(true);
    try {
      const result = await PlayerProfileService.insertUpdateHighSchoolDetails(
        formData
      );
      if (result) {
        getUpdatedHighSchoolGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedHighSchoolGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setHighSchoolGridData(result.data.highSchool);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              High School Details
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="Cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveCLick}
                >
                  <TitleTooltip title="Save high school details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            <Grid item lg={1.4} md={6} sm={12} xs={12}>
              {getInputBox(
                "High School Year",
                highSchoolFormData.years,
                (e) => handleInputChange(e, "years"),
                false,
                "text",
                error.years
              )}
            </Grid>
            <Grid item lg={1.5} md={6} sm={12} xs={12}>
              {getInputBox("High School", highSchoolFormData.schoolName, (e) =>
                handleInputChange(e, "schoolName")
              )}
            </Grid>
            <Grid item lg={1.9} md={6} sm={12} xs={12}>
              {getInputBox(
                "High School Town/City",
                highSchoolFormData.townOrCity,
                (e) => handleInputChange(e, "townOrCity")
              )}
            </Grid>
            <Grid item lg={1.6} md={6} sm={12} xs={12}>
              {getInputBox("High School State", highSchoolFormData.state, (e) =>
                handleInputChange(e, "state")
              )}
            </Grid>
            <Grid item lg={1.6} md={6} sm={12} xs={12}>
              {getInputBox(
                "High School Contact",
                highSchoolFormData.contact,
                (e) => handleInputChange(e, "contact")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox(
                "High School Contact Phone",
                highSchoolFormData.phone,
                (e) => handleInputChange(e, "phone")
              )}
            </Grid>
            <Grid item lg={2} md={6} sm={12} xs={12}>
              {getInputBox(
                "High School Contact Email",
                highSchoolFormData.email,
                (e) => handleInputChange(e, "email"),
                false,
                "text",
                error.email
                // errorMessage.email
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={highSchoolGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => {
              handleOpenCloseConfirmationBox(false);
            }}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};

export default React.memo(HighSchoolDetailsViewUpdate);
